import { useState } from "preact/hooks";
import { convertDateTimeThailand, delay } from "../../../functions";
import { useMessage } from "../../../hooks/useMessage";
import { GET, GET_DEVICES } from "../../../services";
import { IStateDevice } from "../interfaces/state";

export const useGetDevice = () => {
  const { openMessage } = useMessage();
  const [stateDevice, setStateDevices] = useState([] as IStateDevice[]);

  const getDevice = async () => {
    try {
      const res: any = await GET(GET_DEVICES);
      const { devices } = res.result;
      const newData: IStateDevice[] = devices.map(
        (e: IStateDevice, i: number) => ({
          ...e,
          index: i + 1,
          key: e.deviceID,
          createDate: convertDateTimeThailand(e.createDate),
          isAvailableName: e.isAvailable ? "เปิด" : "ปิด",
        })
      );
      setStateDevices(newData);
    } catch (error) {
      console.log(error);
    }
  };

  const onSearch = async (queryString: string) => {
    await delay(2000);
    try {
      const res = await GET(`${GET_DEVICES}?${queryString}`);
      const { devices } = res.result;
      const newData = devices.map((e: IStateDevice, i: number) => ({
        ...e,
        index: i + 1,
        key: e.deviceID,
        createDate: e.createDate ? convertDateTimeThailand(e.createDate) : null,
      }));
      setStateDevices(newData);
      openMessage("success", "โหลดข้อมูลเสร็จสิ้น");
    } catch (error: any) {
      openMessage("error", error.message);
    }
  };

  return {
    getDevice,
    devices: stateDevice,
    setDevice: setStateDevices,
    onSearch,
  };
};
